import { motion } from "framer-motion";
import { ArrowUpRight, Play } from "lucide-react";
import { BRAND } from "../lib/brand";
import { item } from "../lib/motion";
import { PLATFORMS } from "./PlatformIcons";

// Opens the video on its original platform (Facebook / TikTok / YouTube).
export default function VideoCard({ v, index }) {
  const p = PLATFORMS[v.platform] || PLATFORMS.facebook;
  return (
    <motion.a variants={item} href={v.url} target="_blank" rel="noreferrer" data-testid={`video-card-${index}`}
      className="glass-card overflow-hidden group block">
      <div className="relative aspect-[4/5] overflow-hidden bg-black">
        <img src={v.thumbnail || BRAND.vortex} alt={v.title} loading="lazy"
          className={`w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ${v.thumbnail ? "" : "opacity-60"}`} />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/10 to-transparent" />
        <span className="absolute top-4 left-4 glass rounded-full px-3 py-1.5 text-[11px] flex items-center gap-1.5 text-zinc-200" data-testid={`video-platform-${index}`}>
          <p.icon className="w-3.5 h-3.5" /> {p.label}
        </span>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-14 h-14 rounded-full glass flex items-center justify-center glow-blue group-hover:scale-110 transition-transform duration-500">
            <Play className="w-5 h-5 text-white ml-0.5" fill="white" />
          </div>
        </div>
        <div className="absolute bottom-0 inset-x-0 p-5">
          {v.category && <span className="text-[10px] font-semibold uppercase tracking-[0.15em] text-[#7cc4ff]">{v.category}</span>}
          <h3 className="font-head font-medium mt-1.5 leading-snug line-clamp-2">{v.title}</h3>
          <span className="mt-2 inline-flex items-center gap-1 text-xs text-zinc-400 group-hover:text-white transition-colors">
            Watch on {p.label} <ArrowUpRight className="w-3.5 h-3.5" />
          </span>
        </div>
      </div>
    </motion.a>
  );
}
